export default async function createDropzone(el, opts) {
  const [{ default: Dropzone }] = await Promise.all([
    import(/* webpackChunkName: "dropzone" */ "dropzone"),
    import(/* webpackChunkName: "dropzone" */ "dropzone/dist/dropzone.css"),
  ]);

  Dropzone.autoDiscover = false;

  // Check for pre-loaded files
  const params = new URLSearchParams(window.location.search);
  const fileUUID = params.get("files");
  const fileName = params.get("name");
  const fileSize = params.get("size");

  // Strip upload params from the URL so they don't persist on refresh
  if (fileUUID) {
    const url = new URL(window.location.href);
    url.searchParams.delete("files");
    url.searchParams.delete("name");
    url.searchParams.delete("size");
    window.history.replaceState({}, document.title, url.toString());
  }

  const dropzone = typeof el === "string" ? document.querySelector(el) : el;

  if (fileUUID && fileName) {
    const originalInit = opts.init || function () {};
    opts.init = function () {
      originalInit.call(this);

      const mockFile = {
        name: decodeURIComponent(fileName),
        size: parseInt(fileSize || "0", 10),
        uuid: fileUUID,
        status: Dropzone.ADDED,
      };

      this.emit("addedfile", mockFile);
      this.emit("success", mockFile, { uuid: fileUUID });
      this.emit("complete", mockFile);
      this.files.push(mockFile);
    };
  } else if (dropzone?.classList.contains("invisible-dropzone")) {
    // setup event listeners for invisible dropzone element
    // needs custom functions to keep track of entered / left elements
    const originalInit = opts.init || function () {};
    opts.init = function () {
      originalInit.call(this);
      this.dragEnteredElements = [];
    };

    opts.dragenter = function (e) {
      this.dragEnteredElements.push(e.target);
      dropzone.classList.add("dragover");
      document.body.classList.add("fade-background");
    };

    opts.dragleave = function (e) {
      this.dragEnteredElements = this.dragEnteredElements.filter(
        (element) => element !== e.target,
      );

      if (this.dragEnteredElements.length === 0) {
        dropzone.classList.remove("dragover");
        document.body.classList.remove("fade-background");
      }
    };
  }

  return new Dropzone(el, opts);
}
